import { render, staticRenderFns } from "./WxBindLogin.vue?vue&type=template&id=22f37e8c"
import script from "./WxBindLogin.vue?vue&type=script&lang=js"
export * from "./WxBindLogin.vue?vue&type=script&lang=js"
import style0 from "./WxBindLogin.vue?vue&type=style&index=0&id=22f37e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports